<template>
  <div class="crs-19-view">
    <div class="title-bar">
      <span class="title">{{ i18n('general', 'title') }}</span>
      <div v-for="l in langs" :key="l.code" :style="{ backgroundImage: 'url(' + l.flag + ')' }" class="flag" @click="setActiveLang(l.code)"></div>
    </div>
    <div class="left-panel">
      <span class="label" v-if="modelSelection.length > 0">{{ i18n('leftPanel', 'riskOf') }}</span>
      <div class="model-input" v-for="m in modelSelection" :key="m">
        <div class="checkboxes">
          <font-awesome-icon v-if="getGlobalParam('model') === m" :icon="['fas', 'check-circle']"/>
          <font-awesome-icon v-else :icon="['far', 'circle']" @click="setGlobalParam({ name: 'model', value: m })"/>
        </div>
        <span class="label" @click="setGlobalParam({ name: 'model', value: m })">{{ i18n('leftPanel', m) }}</span>
      </div>
      <span class="label">{{ i18n('leftPanel', 'observation') }}</span>
      <Observation />
    </div>
    <div v-if="displaySurvey" class="survey-view">
      <LangSelect v-if="isDefault" />
      <Survey v-else @done="displaySurvey = false"/>
    </div>
    <div :class="{ invisible: displaySurvey }" class="main-view">
      <button class="survey-start" @click="displaySurvey = true">{{ i18n('general', 'startSurvey') }}</button>
      <Description />
      <OneModelView v-for="model in availableParams.model"  :key="model" :model="model" :class="{ desktopInvisible: getGlobalParam('model') !== model }"/>
      <ModelInfo />
      <footer v-html="i18n('general', 'footer')" />
    </div>
  </div>
</template>
<script>
import Observation from '@/components/Observation.vue'
import Survey from '@/components/Survey.vue'
import Description from '@/components/Description.vue'
import OneModelView from '@/components/OneModelView.vue'
import LangSelect from '@/components/LangSelect.vue'
import ModelInfo from '@/components/ModelInfo.vue'
import format from '@/utils/format.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Crs19View',
  data () {
    return {
      displaySurvey: true
    }
  },
  filters: {
    formatTitle: format.formatTitle,
    firstCharUpper: format.firstCharUpper
  },
  computed: {
    modelSelection () {
      return (this.availableParams.model.length > 1) ? this.availableParams.model : []
    },
    ...mapGetters(['getGlobalParam', 'availableParams', 'langs', 'i18n', 'isDefault'])
  },
  methods: {
    ...mapMutations(['setGlobalParam', 'setActiveLang'])
  },
  components: {
    Observation,
    Survey,
    Description,
    OneModelView,
    LangSelect,
    ModelInfo
  }
}
</script>
<style>
.crs-19-view {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.crs-19-view > .title-bar {
  height: 50px;
  width: 100%;
  border-bottom: 2px solid #eee;
}
.crs-19-view > .title-bar > div.flag {
  width: 30px;
  height: 20px;
  position: relative;
  top: 12px;
  left: 50px;
  display: inline-block;
  background-size: cover;
  background-position: center;
  margin: 0 5px;
  box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
  cursor: pointer;
}
.crs-19-view > .title-bar > .title {
  position: relative;
  font-size: 26px;
  color: #371ea3;
  top: 12px;
  left: 15px;
  font-family: 'FiraSansBold'
}
.crs-19-view > .left-panel {
  width: 300px;
  border-right: 2px solid #eee;
  border-bottom: 2px solid #eee;
}
.crs-19-view > .main-view {
  width: calc(100% - 300px);
  left: 300px;
  top: 52px;
  position: absolute;
}
.crs-19-view > .main-view > button.survey-start {
  color: white;
  background: #46bac2;
  box-shadow: 0 0 5px 0 #46bac240;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 24px;
  border: none;
  position: relative;
  left: 50%;
  top: -20px;
  display: none;
  transform: translateX(-50%);
}
.crs-19-view > .main-view > .model-selection {
  display: none;
}
.crs-19-view > .survey-view {
  display: none;
}
.crs-19-view > .left-panel > span.label {
  font-size: 18px;
  color: #371ea3;
  width: calc(100% - 30px);
  display: inline-block;
  font-weight: 600;
  margin: 15px 0 4px 30px;
}
.crs-19-view > .left-panel > div.model-input {
  position: relative;
  padding: 3px 0 3px 45px;
}
.crs-19-view > .left-panel > div.model-input > div.checkboxes {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  color: #371ea3;
  cursor: pointer;
}
.crs-19-view > .left-panel > div.model-input > span.label {
  font-size: 16px;
  cursor: pointer;
}
.crs-19-view footer {
  margin: -15px 30px 0 30px;
  padding-bottom: 10px;
  text-align: right;
}
.crs-19-view footer > a {
  color: #4378bf;
}
@media (min-width: 1201px) {
  .crs-19-view  .desktopInvisible {
    height: 0;
    overflow: hidden;
    padding: 0;
    margin: 0;
  }
}
@media (max-width: 1200px) {
  .crs-19-view > .main-view > footer {
    font-size: 20px;
  }
  .crs-19-view > .left-panel {
    width: 100%;
    border-right: none;
    display: none;
  }
  .crs-19-view > .main-view {
    width: 100%;
    position: relative;
    left: 0;
  }
  .crs-19-view > .title-bar > div.flag {
    display: none;
  }
  .crs-19-view .invisible {
    height: 0;
    overflow: hidden;
  }
  .crs-19-view > .survey-view {
    display: block;
    width: 100%;
    top: 52px;
    position: absolute;
    height: calc(100% - 52px);
  }
  .crs-19-view > .main-view > button.survey-start {
    display: inline;
  }
  .crs-19-view > .main-view > .model-selection {
    display: block;
  }
}
</style>
